export default "__VITE_ASSET__aW1OwHa1__"